const TITLE = "Requested: the customer asked for a pickup, and no pickup collected it before this day.";

export function RequestedMark() {
  return (
    <span className="chip-flag" data-testid="stop-requested" title={TITLE} aria-label={TITLE}>
      Requested
    </span>
  );
}
